/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react'
import '../App.css'
import '../styles/MainContainer.css'
import './aboutus.css'
import 'react-datepicker/dist/react-datepicker.css'
//import TopBar from '../components/TopBar.jsx'

function Faq() {
  const [visibleSection, setVisibleSection] = useState(null) // Manages which section is visible
  const [toggle, setToggle] = useState(true)

  const toggleVisibility = section => {
    if (visibleSection === section) {
      setVisibleSection(null) // Close the section if it's already open
    } else {
      setVisibleSection(section) // Open the clicked section and close others
    }
  }
  return (
    <div>
      <div className="GlobalContainer">
        <div style={{ zIndex: 1 }}>
         
          <div className='p-6 mt-[147px] sm:mt-0 md:p-[2px] flex flex-col-reverse xl:flex-row gap-8 items-center xl:items-start xl:gap-[0px] text-white justify-center'>
            <div className='flex flex-col max-w-[800px] gap-6 md:gap-[40px]'>
              <div className="m-auto px-4 sm:px-12 sm:py-10">
                <h1 className="text-[32px] leading-[110%] tracking-[-2%] mb-2 font-bold">We are here to answer your questions</h1>
                <div className='w-full flex rounded-[10px] overflow-hidden mt-2'>
                  <img src="/img/banner.jpg" width={800} className='' />
                </div>
                <section className="lg:mx-auto pt-4 lg:py-[30px] w-full lg:w-[741px] min-w-0">
                  <div
                    className="Text1 text-[20px] font-light"
                    style={{
                      textAlign: 'center'
                    }}
                  >
                    Here are answers to some of the most common questions about Meme Base Fun. Still can’t find what you’re searching for? Let us know, and we’ll help guide you!
                  </div>
                  <a href="https://t.me/" target="_blank" className="p-[4px]">
                    <div
                      className="Text1 text-[20px] sort-button selected text-center"
                    >
                      Chat with us now!
                    </div>
                  </a>
                </section>
              </div>
              <div className="m-auto sm:px-12 w-full">
                <div className="flex justify-center gap-0 relative">
                  <button
                    className={`sort-button ${toggle ? 'selected' : 'text-gray-400'} mr-3`}
                    onClick={() => setToggle(true)}
                  >
                    Investors
                  </button>
                  <button
                    className={`sort-button ${!toggle ? 'selected' : 'text-gray-400'}`}
                    onClick={() => setToggle(false)}
                  >
                    Developers
                  </button>
                </div>
                <div className="flex flex-col mt-6">
                  {!toggle && <div className="flex flex-col">
                    <div
                      className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                        , cursor: 'pointer'
                      }}
                      onClick={() => toggleVisibility(0)}
                    >
                      <div className="Text1 text-[11px] lg:text-[14px]" style={{ cursor: "pointer" }}>
                        How does Meme Base Fun benefit developers.
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 0 ? 'rotate-180' : ''}`}>
                        <path d="m6 9 6 6 6-6"></path>
                      </svg>
                    </div>
                    {visibleSection === 0 && (
                      <div
                        className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] lg:px-8 px-2.5"
                      >
                        <div
                          className="Text1 text-[11px] lg:text-[14px]"
                        >
                          Meme Base Fun streamlines the token deployment process, making it fast, easy, and affordable. In just a minute, you can launch your token and instantly reach thousands of potential investors on the platform. Plus, with the FEATURED option, you gain premium exposure and marketing to maximize your token’s visibility. Meme Base Fun is the perfect platform for developers looking to bring their projects to life quickly and effectively.
                        </div>
                      </div>
                    )}
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(1)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px]"
                            style={{ cursor: "pointer" }}
                          >
                            Which coding skills do i need to deploy a token?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 1 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 1 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px',
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              None! You don’t need any coding experience to deploy a token on Meme Base Fun. All you have to do is fill out a few details and pay the deployment transaction fee. It’s that simple—launch your token in no time without worrying about technical skills.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(2)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px] max-w-[90%]"
                            style={{ cursor: "pointer" }}
                          >
                            How much does it cost to launch a project with Meme Base Fun?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 2 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 2 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px',
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              It’s super affordable! The BASIC launch costs only around $2 to $3 plus gas fees. If you want the FEATURED OPTION to ensure top visibility and marketing for your project, it’s about $250. You can choose what works best for your project, whether it’s a budget-friendly option or full-blown exposure!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(3)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px]"
                            style={{
                            }}
                          >
                            How can I start investing in Meme Base Fun?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 3 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 3 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px',
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              It’s super simple! Just connect your wallet, and you’re good to go. Explore various projects on our homepage, where you can easily filter options to find the perfect investment for you, whether it’s based on the project type or your preferred blockchain. With just a few clicks, you’re on your way to discovering exciting new tokens!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(4)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px]"
                            style={{ cursor: "pointer" }}
                          >
                            Are there trading fees on Meme Base Fun?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 4 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 4 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px',
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              YES! There’s a small 1% fee on every trade. But here’s the fun part: you can earn 50% of those fees just by sharing your referral link! Each token page has its own referral link ready for you to grab, so refer your friends and start earning today. It’s that easy!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(5)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px] max-w-[90%]"
                            style={{ cursor: "pointer" }}
                          >
                            Are there other ways to earn money through
                            Meme Base Fun?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 5 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 5 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px'
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              Absolutely! You don’t need to invest to make money. Refer your friends and earn{' '}
                              <span style={{ fontWeight: 'bold' }}>
                                {' '}
                                50% of the fees{' '}
                              </span>
                              on every trade they make. It’s easy—just grab your referral link from any token page and share it to start earning. Meme Base Fun makes earning as simple as sharing!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>}

                  {toggle && <div className="flex flex-col">
                    <div
                      className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66] border-[#ffffff66]"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                        , cursor: 'pointer'
                      }}
                      onClick={() => toggleVisibility(6)}
                    >
                      <div
                        className="Text1 text-[11px] lg:text-[14px]"
                        style={{ cursor: "pointer" }}
                      >
                        What is Meme Base Fun?
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 6 ? 'rotate-180' : ''}`}>
                        <path d="m6 9 6 6 6-6"></path>
                      </svg>
                    </div>
                    {visibleSection === 6 && (
                      <div
                        className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                        style={{
                          border: '2px solid #050f1a',
                          zIndex: '-1',
                          marginTop: '0px'
                        }}
                      >
                        <div
                          className="Text1 text-[11px] lg:text-[14px]"
                          style={{
                            
                          }}
                        >
                          Meme Base Fun is your go-to platform for launching tokens without all the hassle! It’s built to make token deployment easy and fast, while giving investors a sneak peek into the hottest, most secure crypto projects before they take off. If you’re all about finding the next big thing in crypto—safely—then you’re in the right place!
                        </div>
                      </div>
                    )}
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(7)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px]"
                            style={{ cursor: "pointer" }}
                          >
                            How does Meme Base Fun make life sweeter for investors?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 7 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 7 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px'
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              It gives you an insider pass to brand-new tokens before they hit the big DEX stages! This means you get a chance to scoop up tokens early, boosting your potential for major returns while keeping things secure. Early bird gets the best crypto worms!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(8)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px]"
                            style={{ cursor: "pointer" }}
                          >
                            Is investing in Meme Base Fun safe?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 8 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 8 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px'
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              Absolutely! Meme Base Fun takes the guesswork out of safety by managing both the liquidity pool and token contract. This creates a far more secure environment than the wild, scam-filled markets you’re used to. Forget worrying about bad actors—Meme Base Fun keeps your investments protected while you focus on those crypto gains!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(9)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px]"
                            style={{ cursor: "pointer" }}
                          >
                            How can I start investing on Meme Base Fun?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 9 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 9 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px'
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              Getting started is super simple! Just connect your wallet, and you’re all set. Browse through a variety of exciting projects right on our homepage. You can easily filter through them to find the perfect one for you, based on your favorite chain to trade on. It’s quick, easy, and puts you right at the heart of promising crypto opportunities!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(11)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px] max-w-[90%]"
                            style={{ cursor: "pointer" }}
                          >
                            What happens when a token reaches a $69,000 market cap?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 11 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 11 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px'
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              When a token hits the $69,000 market cap milestone, it’s automatically listed on a DEX with $13,800 in liquidity. Plus, to boost safety, the LP tokens are burned, and the contract is renounced—giving investors even more peace of mind while trading. It’s all about making the process more secure and seamless for you!
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="grid xl:grid-cols-1 gap-12"
                      style={{ marginTop: '20px' }}
                    >
                      <div className="flex flex-col">
                        <div
                          className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                            , cursor: 'pointer'
                          }}
                          onClick={() => toggleVisibility(12)}
                        >
                          <div
                            className="Text1 text-[11px] lg:text-[14px] max-w-[90%]"
                            style={{ cursor: "pointer" }}
                          >
                            Are there other ways to earn money through Meme Base Fun?
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${visibleSection === 12 ? 'rotate-180' : ''}`}>
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                        </div>
                        {visibleSection === 12 && (
                          <div
                            className="bg-[#6d79ad33] rounded-[10px] py-5 backdrop-blur-[8px] border-2 lg:px-8 px-2.5 border-[#ffffff66]"
                            style={{
                              border: '2px solid #050f1a',
                              zIndex: '-1',
                              marginTop: '0px'
                            }}
                          >
                            <div
                              className="Text1 text-[11px] lg:text-[14px]"
                              style={{
                                
                              }}
                            >
                              Yes, absolutely! You don’t need to invest money to start earning. Launch your project or refer friends to earn{' '}
                              <span style={{ fontWeight: 'bold' }}>
                                {' '}
                                50% of the fees.{' '}
                              </span>
                              Simply grab your referral link from any token page, and you’re ready to go! Whether you’re investing or spreading the word, you can make your mark on Meme Base Fun.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Faq
